import {useIntl} from 'react-intl'
import {Table} from 'src/feature/bite/component/Table'
import {useProduct} from '../../hook'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

const Tool = (text: any) => {
  if (text.length < 20) {
    return <>{text}</>
  }

  return (
    <OverlayTrigger
      placement='right'
      delay={{show: 250, hide: 400}}
      overlay={(props) => (
        <Tooltip id='button-tooltip' {...props}>
          {text}
        </Tooltip>
      )}
    >
      <span className='menu-link menu-center'>{text.slice(0, 20) + '...'}</span>
    </OverlayTrigger>
  )
}

const ProductList = ({loading}: {loading: boolean}) => {
  const intl = useIntl()
  const {list, listFilter, listFilterSet} = useProduct()

  const columns = [
    {
      key: 'ProductId',
      dataIndex: 'skuID',
      title: intl.formatMessage({id: 'PRODUCT.LIST.PRODUCT_ID'}),
      tooltip: intl.formatMessage({id: 'PRODUCT.LIST.PRODUCT_ID_TOOLTIP'}),
      render: (text: any) => Tool(text),
    },
    {
      key: 'name',
      dataIndex: 'productName',
      title: intl.formatMessage({id: 'PRODUCT.LIST.PRODUCT_NAME'}),
      render: (text: any) => Tool(text),
    },
    {
      key: 'status',
      dataIndex: 'status',
      title: intl.formatMessage({id: 'PRODUCT.LIST.STATUS'}),
      status: true,
    },
    {
      key: 'Category',
      dataIndex: 'categoryName',
      title: intl.formatMessage({id: 'PRODUCT.LIST.CATEGORY'}),
      render: (text: any) => Tool(text),
    },
    {
      key: 'Price',
      dataIndex: 'price',
      title: intl.formatMessage({id: 'PRODUCT.LIST.PRICE'}) + ' ($)',
      render: (text: any) => <>{text.toFixed(2)}</>,
    },
    {
      key: 'BARCODE',
      dataIndex: 'barcode',
      title: intl.formatMessage({id: 'PRODUCT.LIST.BARCODE'}),
      render: (text: any) => Tool(text),
    },
    {
      key: 'SUB_CATEGORY',
      dataIndex: 'subCategoryName',
      title: intl.formatMessage({id: 'PRODUCT.LIST.SUB_CATEGORY'}),
      render: (text: any) => Tool(text),
    },
    {
      key: 'APPROVED_PRODUCT',
      dataIndex: 'approvedProduct',
      title: intl.formatMessage({id: 'PRODUCT.LIST.APPROVED_PRODUCT'}),
      yesOrNo: true,
    },
    {
      key: 'PAY_WITH_POINTS',
      dataIndex: 'payWithPoints',
      title: intl.formatMessage({id: 'PRODUCT.LIST.PAY_WITH_POINTS'}),
      yesOrNo: true,
    },
    {
      key: 'ELIGIBLE_FOR_POINTS',
      dataIndex: 'eligibleForPoints',
      title: intl.formatMessage({id: 'PRODUCT.LIST.ELIGIBLE_FOR_POINTS'}),
      yesOrNo: true,
    },
    {
      key: 'ELIGIBLE_FOR_DISCOUNT',
      dataIndex: 'eligibleForDiscount',
      title: intl.formatMessage({id: 'PRODUCT.LIST.ELIGIBLE_FOR_DISCOUNT'}),
      yesOrNo: true,
    },
    {
      key: 'action',
      dataIndex: 'id',
      title: intl.formatMessage({id: 'PRODUCT.LIST.ACTION'}),
      render: (id: string) => (
        <a href={`/products/${id}`}>{intl.formatMessage({id: 'PRODUCT.LIST.DETAIL'})}</a>
      ),
    },
  ]

  return (
    <Table
      loading={loading}
      dataSource={list.dataList}
      columns={columns}
      tableName={'products'}
      pagination={{
        current: listFilter.paging.currentPageNumber,
        pageSize: listFilter.paging.pageSize,
        total: list.paging.totalCount,
        onChange: (page: any) => {
          const {pageSize, current} = page
          const currentPage = pageSize !== listFilter.paging.pageSize ? 1 : current

          listFilterSet({
            ...listFilter,
            paging: {
              ...listFilter.paging,
              pageSize,
              currentPageNumber: currentPage,
            },
          })
        },
      }}
    />
  )
}

export default ProductList
